export const FaqItem = [
  {
    question: 'Do you offer emergency plumbing services?',
    answer:
      'Yes, we provide 24/7 emergency plumbing services. If you have a burst pipe, a major leak, or any urgent plumbing issue, call us immediately for a rapid response.',
    open: false,
  },
  {
    question: 'How quickly can you respond to an emergency call-out?',
    answer:
      'We aim to reach you as soon as possible. Our average response time for emergency call-outs is within the hour, depending on your location and traffic conditions.',
    open: false,
  },
  {
    question: 'How do I book a plumbing service?',
    answer:
      'You can book a service by calling us directly, filling out our online booking form, or sending us a message via our contact page. We’ll get back to you to confirm the appointment at your convenience.',
    open: false,
  },
  {
    question: 'What areas do you cover?',
    answer:
      'We provide plumbing and heating services across London and all surrounding areas. If you’re unsure whether we cover your location, please get in touch with us.',
    open: false,
  },
  {
    question: 'What types of plumbing issues do you handle?',
    answer:
      'We handle all types of plumbing issues, including leaks, blockages, pipe repairs, boiler servicing, central heating repairs, bathroom installations, and more.',
    open: false,
  },
  {
    question: 'Are your plumbers qualified and insured?',
    answer:
      'Yes, all our plumbers are fully qualified, Gas Safe registered, and insured, ensuring safe and professional workmanship on every job.',
    open: false,
  },
  {
    question: 'Do you work with both residential and commercial clients?',
    answer:
      'Yes, we provide plumbing and heating services for both residential and commercial properties, including offices, retail spaces, and rental properties.',
    open: false,
  },
];
